import React from "react";
import { Button, Modal } from "@mui/joy";
import TickCircle from "../../assets/svgs/tick-circle.svg";

interface PaymentSuccessProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  buttonText?: string;
}

const PaymentSuccess: React.FC<PaymentSuccessProps> = ({
  open,
  onClose,
  title = "Payment Successful!",
  subtitle = "Your payment has been processed successfully.",
  buttonText = "Continue",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="payment-success-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiModal-backdrop": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "none",
        },
      }}
    >
      <div className="bg-white rounded-xl p-6 w-[90%] max-w-[390px] text-center">
        <div className="flex justify-center mb-4">
          <div className="w-12 h-12 flex items-center justify-center">
            <img src={TickCircle} alt="Success" />
          </div>
        </div>

        <h3 className="text-xl font-semibold mb-2">{title}</h3>

        <p className="text-gray-500 text-base">{subtitle}</p>

        <Button
          variant="solid"
          color="primary"
          fullWidth
          onClick={onClose}
          sx={{
            height: 48,
            marginTop: "24px",
          }}
        >
          {buttonText}
        </Button>
      </div>
    </Modal>
  );
};

export default PaymentSuccess;
